/**
 * The guest "order" hand-off. A product card on the landing's assortment page links to the
 * buyer app as `/?category=<slug>`; the slug has to survive the bounce through the landing's
 * login page so the buyer lands in the category they clicked from.
 *
 * It is a SLUG, never a URL: only the shape `catalog.Slugify` produces is accepted, and the
 * apps build the destination path themselves. That is the difference between this and the
 * `?next=` parameter `evaluateGuard` refuses to carry.
 */
export const CATEGORY_PARAM = 'category';

const CATEGORY_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const CATEGORY_SLUG_MAX = 80;

/** The category slug in a query string, or null when absent or not slug-shaped. */
export function categoryIntent(search: string): string | null {
  const slug = new URLSearchParams(search).get(CATEGORY_PARAM);
  if (!slug || slug.length > CATEGORY_SLUG_MAX || !CATEGORY_SLUG.test(slug)) return null;
  return slug;
}

/** `to` with the current query string's category slug carried over, if it has a valid one. */
export function withCategoryIntent(to: string, search: string): string {
  const slug = categoryIntent(search);
  return slug ? `${to}?${CATEGORY_PARAM}=${slug}` : to;
}
